import { useState } from "react";
import TextInput, { InputTypes } from "../TextInput";
import { Button, ButtonTypes } from "../Button";
import { Alert, AlertTypes } from "../Alert";
import { Modal } from "../Modal";
import { Table } from "../Table";
import { reactivateStudentApplication, reactivateStudentApplicationOverview, ReactivateStudentApplicationOverviewResponse } from "../../api/tools";

export default function ReactivateStudentApplication() {
    const [studentApplicationId, setStudentApplicationId] = useState(0);
    const [errorResponse, setErrorResponse] = useState('');
    const [successReponse, setSuccessResponse] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [overview, setOverview] = useState({} as ReactivateStudentApplicationOverviewResponse | null);

    function isFormValid() {
        return studentApplicationId;
    }

    async function handleSubmit(e: Event) {
        e.preventDefault();
        const overview = await reactivateStudentApplicationOverview({ studentApplicationId });
        setOverview(overview);
        setShowModal(true);
    }
    

    async function submit(e: Event) {
        e.preventDefault();
        resetState();
        const response = await reactivateStudentApplication({ studentApplicationId });
        if (response?.exception) {
            setErrorResponse(response?.message);
        } else {
            setSuccessResponse(response?.message);
        }
    }

    function resetState() {
        setErrorResponse('');
        setSuccessResponse('');
        setOverview(null);
        setShowModal(false);
    }

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <div className="card mb-4 full-width">
                        <h5 className="card-header">Re-activate student application</h5>
                        <div className="card-body">
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <TextInput
                                        onValue={(value: number) => setStudentApplicationId(value)}
                                        label="Student application ID"
                                        placeholder="8067"
                                        description="ID of the student application"
                                        type={InputTypes.NUMBER}
                                    />
                                </div>
                            </div>
                            <div className="pt-4">
                                <Button type={ButtonTypes.PRIMARY} text="Reactivate student application" className={!isFormValid() ? 'disabled' : ''} onPress={(e: Event) => handleSubmit(e)} />
                            </div>
                            {errorResponse && (
                                <div className="pt-4">
                                    <Alert type={AlertTypes.DANGER} text={errorResponse} />
                                </div>
                            )}
                            {successReponse && (
                                <div className="pt-4">
                                    <Alert type={AlertTypes.SUCCESS} text={successReponse} />
                                </div>
                            )}
                            {showModal && (
                                <Modal
                                    title="Details about the action"
                                    onConfirm={(e: Event) => submit(e)}
                                    onCancel={(e: Event) => setShowModal(false)}
                                >
                                    {overview?.applicationId && overview?.corporation && overview?.name && overview?.email && (
                                        <>
                                            <Table
                                                cols={[
                                                    { name: 'Id' },
                                                    { name: 'Corporation' },
                                                    { name: 'Name' },
                                                    { name: 'Email' }
                                                ]}
                                                rows={[
                                                    {
                                                        cells: [
                                                            { content: `${overview.applicationId}` },
                                                            { content: `${overview.corporation}` },
                                                            { content: `${overview.name}` },
                                                            { content: `${overview.email}` }
                                                        ]
                                                    }
                                                ]}
                                            />
                                        </>
                                    )}
                                    <p className="mt-4 fw-bold">Are you sure you want to proceed?</p>
                                </Modal>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}